/**
 * Hook de autenticacao que consome o AuthContext do AuthProvider.
 */
'use client';

import { useContext } from 'react';
import { AuthContext, type AuthContextValue } from '@/providers/auth-provider';

/**
 * Retorna os dados de autenticacao do contador logado.
 * Deve ser usado dentro de um AuthProvider.
 */
export function useAuth(): AuthContextValue {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth deve ser usado dentro de um AuthProvider');
  }
  return context;
}
